import * as React from 'react';
import { SVGType } from '../types';

type IChainIconProps = SVGType;

export const ChainIcon: React.FunctionComponent<IChainIconProps> = ({ size = 48, stroke = '#E02424', ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 48 48" {...rest}>
      <path
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
        d="M27.653 20.344a8 8 0 00-11.312 0l-8 8a8 8 0 1011.312 11.312l2.204-2.202m-1.516-9.798a8 8 0 0011.312 0l8-8A8 8 0 0028.34 8.344l-2.2 2.2"
      ></path>
    </svg>
  );
};

export default ChainIcon;
